/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingDemoTranscript = [
  { type: 'heading', level: 2, text: 'Transcript' },
  { type: 'paragraph', text: '13:02 — Alex Morgan: Agenda is launch timeline and design review.' },
  { type: 'paragraph', text: '13:08 — Jordan: Deck due Tuesday; review Thursday 2pm.' },
  { type: 'paragraph', text: '13:15 — Sam: Telemetry for transcribe and note creation in progress.' },
  { type: 'paragraph', text: '13:28 — Taylor: Vendor transcript quality acceptable for pilot with caveats.' },
]
